module.exports = __webpack_public_path__ + "static/media/iconFaqEpargn.bf8d1d8b.svg";